const hochuaStyle = () => ({
  root: {
    "& .MuiInputBase-root": {
      color: "#fff",
    },
  },
  row: {
    color: "#f9ff00",
    marginLeft: "2px",
  },
  table: {
    width: "100%",
    fontSize: "0.85vw",
    borderCollapse: "collapse",
    borderTop: "1px solid #4f7edb",
  },
  a: {
    color: "blue",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "blue",
    },
  },
  a_chitet_title: {
    color: "blue",
    fontSize: "3vh",
    fontWeight: "900",
  },
  a_chitet_ngaythang: {
    color: "black",
    fontSize: "1.7vh",
    fontWeight: "700",
  },
  a_chitet_file: {
    color: "#af0202",
    fontSize: "2vh",
    fontWeight: "900",
  },
  a_chitet: {
    color: "black",
    fontSize: "1.8vh",
    fontWeight: "600",
  },
  table_td: {
    border: "1px solid #4f7edb",
    color: "#00ec00",
    textAlign: "center",
    fontWeight: "700",
  },
  img: {
    height: "10%",
    marginTop: "5px",
  },
});

export default hochuaStyle;
